(() => {
  if (window.bdDocumentsInitialized) return;
  window.bdDocumentsInitialized = true;
  const normalize = text => text.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  function mount(scope) {
    scope.querySelectorAll('[data-bd-documents]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const input = root.querySelector('[data-doc-search]');
      const area = root.querySelector('[data-doc-area]');
      const controls = root.querySelector('[data-doc-controls]');
      if (!input || !area || !controls) return;
      const rows = [...root.querySelectorAll('[data-doc-row]')];
      const count = root.querySelector('[data-doc-count]');
      const empty = root.querySelector('[data-doc-empty]');
      const groups = [...root.querySelectorAll('[data-doc-group]')];
      const initiallyOpen = new Map(groups.map(group => [group, group.open]));
      const requestedArea = new URLSearchParams(window.location.search).get('bereich');
      if ([...area.options].some(option => option.value === requestedArea)) area.value = requestedArea;
      function filter() {
        const terms = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
        let visible = 0;
        rows.forEach(row => {
          const group = row.closest('[data-doc-group]');
          const matchesArea = area.value === 'alle' || group?.dataset.area === area.value;
          const text = normalize(row.textContent);
          row.hidden = !matchesArea || !terms.every(term => text.includes(term));
          if (!row.hidden) visible++;
        });
        groups.forEach(group => {
          group.hidden = ![...group.querySelectorAll('[data-doc-row]')].some(row => !row.hidden);
          group.open = terms.length > 0 || area.value !== 'alle' ? !group.hidden : initiallyOpen.get(group);
        });
        root.querySelectorAll('[data-doc-section]').forEach(section => { section.hidden = ![...section.querySelectorAll('[data-doc-row]')].some(row => !row.hidden); });
        count.textContent = `${visible} ${visible === 1 ? 'Eintrag' : 'Einträge'}`;
        empty.hidden = visible > 0;
      }
      controls.hidden = false;
      input.addEventListener('input', filter);
      area.addEventListener('change', filter);
      root.querySelector('[data-doc-reset]').addEventListener('click', () => {
        input.value = ''; area.value = 'alle'; filter(); input.focus();
      });
      root.querySelectorAll('.bd-docs__nav a[href^="#"]').forEach(link => {
        link.addEventListener('click', () => {
          input.value = ''; area.value = 'alle'; filter();
          const target = root.querySelector(link.getAttribute('href'));
          if (target?.tagName === 'DETAILS') target.open = true;
        });
      });
      filter();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document));
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
